<!--
  App.vue · 顶层布局壳
  职责：左右布局（左 Sidebar 导航 + 右 RouterView 页面）+ 全局 Toast
  具体页面逻辑在各 views/*.vue 里
-->
<template>
  <div class="app-container">
    <AppSidebar />
    <main class="main-content">
      <RouterView />
    </main>
    <!-- 全局 Toast（由 usePlayerState.toast() 写入文本） -->
    <div id="toast" ref="toastRef" class="toast"></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AppSidebar from '@/components/AppSidebar.vue'
import { setToastEl } from '@/composables/usePlayerState'

const toastRef = ref(null)
onMounted(() => setToastEl(toastRef.value))
</script>

<style scoped>
.app-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}
.main-content {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 16px;
}
</style>
